import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from '@/api/entities';
import { createPageUrl } from '@/utils';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { Leaf, Award, Heart } from 'lucide-react';

export default function LandingPage() {
    const navigate = useNavigate();

    const handleStart = async () => {
        try {
            // Prova a vedere se l'utente è già loggato
            const user = await User.me();
            // Se sì, mandalo alla dashboard
            navigate(createPageUrl('Dashboard'));
        } catch (error) {
            // Se non è loggato, avvia il processo di login
            await User.login(); 
            // Dopo il login, l'utente verrà reindirizzato e il layout gestirà il setup.
        }
    };

    return (
        <div className="min-h-screen w-full bg-gradient-to-br from-gray-50 to-blue-100 flex flex-col items-center justify-center p-4 text-center">
            <motion.main
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="max-w-3xl mx-auto"
            >
                <motion.div 
                    className="w-24 h-24 bg-gradient-to-r from-blue-500 to-purple-600 rounded-3xl flex items-center justify-center shadow-2xl mb-8 mx-auto"
                    animate={{ rotate: 360 }}
                    transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
                >
                    <Leaf className="w-12 h-12 text-white" />
                </motion.div>

                <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight">
                    Smetti di Fumare. <br/>
                    Inizia a <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Vivere Meglio</span>.
                </h1>

                <p className="mt-6 text-lg md:text-xl text-gray-600 max-w-xl mx-auto">
                    Un percorso guidato con lezioni, esercizi pratici e supporto quotidiano per aiutarti a liberarti dalla sigaretta per sempre.
                </p>

                <motion.div 
                    className="mt-10"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    <Button 
                        onClick={handleStart} 
                        size="lg" 
                        className="bg-gradient-to-r from-blue-500 to-purple-600 text-white font-bold text-lg px-8 py-6 rounded-full shadow-lg"
                    >
                        Inizia il tuo percorso, è gratis
                    </Button>
                </motion.div>

                <div className="mt-12 flex flex-wrap justify-center gap-8 text-gray-700">
                    <div className="flex items-center gap-2">
                        <Heart className="w-5 h-5 text-pink-500" />
                        <span>Supporto quotidiano</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <Award className="w-5 h-5 text-yellow-500" />
                        <span>Traguardi e Ricompense</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <Leaf className="w-5 h-5 text-green-500" />
                        <span>Esercizi pratici</span>
                    </div>
                </div>
            </motion.main>
        </div>
    );
}